import React, { useContext, useEffect, useState, useMemo, useRef } from "react";
import { useTheme } from "@mui/material/styles";
/* para que salga el logueo */
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
/* para que salga el logueo */
import {
  Card,
  CardContent,
  CardHeader,
  Typography,
  Divider,
  Box,
  Button,
  TextField,
  Tooltip,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";

import Popover from "@mui/material/Popover";

import dayjs from "dayjs";

import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Avatar from "@mui/material/Avatar";
import TreeView from "react-treeview";
import "react-treeview/react-treeview.css";
import { SidebarContext } from "../Sidebar/SidebarProvider";

import {
  FolderOpen as FolderOpenIcon,
  AccountTreeOutlined as AccountTreeOutlinedIcon,
} from "@mui/icons-material";

import EditIcon from "@mui/icons-material/Edit";

import {
  getProductosEnProduccion,
  getTimelineByProductId,
  updateTimelineTask,
} from "../../api/Estimates/estimatesApi";

import { getFileContent } from "../../api/Proyectos/projectFilesApi";

const CriticalPath = () => {
  const theme = useTheme();

  const styles = {
    LineasCalendar: {
      width: "7em",
      minHeight: ".65em",
      textAlign: "center",
      "& .MuiInputBase-root": {
        fontSize: ".8em",
      },
      "& .MuiInputBase-input ": {
        padding: "5.245px 6px 5.245px 6px!important",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        border: "none",
      },
    },
  };
  /* para que salga el logueo */
  const navigate = useNavigate();
  /* para que salga el logueo */
  /*  const { isMinimized } = useContext(SidebarContext);
  const marginLeft = isMinimized ? "4em" : "15em"; */
  const { contentMargin } = useContext(SidebarContext);

  const [productos, setProductos] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [expandedNodes, setExpandedNodes] = useState({});
  /*   📌 📥 Obtener timeline cuando se seleccione un producto */
  const [timeline, setTimeline] = useState([]);
  const [loading, setLoading] = useState(false);
  const [timelines, setTimelines] = useState({}); // Guarda timeline por producto

  /* fotos */
  const [budgetImages, setBudgetImages] = useState({});

  /* Popover para ver las miniaturas */
  const [anchorEl, setAnchorEl] = useState(null);
  const [hoveredImage, setHoveredImage] = useState(null);
  const [isHovering, setIsHovering] = useState(false);
  const [closeTimeout, setCloseTimeout] = useState(null);

  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [pendingTask] = useState(null);
  const [pendingDate] = useState(null);

  const [editableExpectedDates, setEditableExpectedDates] = useState({});

  const handleMouseEnterThumb = (event, imageUrl) => {
    clearTimeout(closeTimeout); // Evita que se cierre antes de tiempo
    setAnchorEl(event.currentTarget);
    setHoveredImage(imageUrl);
    setIsHovering(true);
  };

  const handleMouseLeaveThumb = () => {
    setIsHovering(false);
    setCloseTimeout(
      setTimeout(() => {
        if (!isHovering) {
          setAnchorEl(null);
          setHoveredImage(null);
        }
      }, 50), // 🔹 Reducido a 50ms para un cierre más ágil
    );
  };

  const handlePopoverEnter = () => {
    clearTimeout(closeTimeout); // Evita que se cierre al mover el ratón rápido
    setIsHovering(true);
  };

  const handlePopoverLeave = () => {
    setIsHovering(false);
    setCloseTimeout(
      setTimeout(() => {
        if (!isHovering) {
          setAnchorEl(null);
          setHoveredImage(null);
        }
      }, 50), // 🔹 Reducido a 50ms para evitar sensación de retardo
    );
  };
  /* Popover para ver las miniaturas */

  // 📌 Obtener los productos aceptados en producción desde la API
  useEffect(() => {
    /* para que salga el logueo */
    const token = localStorage.getItem("token");
    if (!token) {
      navigate("/login");
    } else {
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        if (decodedToken.exp < currentTime) {
          localStorage.removeItem("token");
          navigate("/login");
        }
      } catch (error) {
        console.error("Error decoding token:", error);
        navigate("/login");
      }
    } /* para que salga el logueo */

    const fetchProductos = async () => {
      try {
        const data = await getProductosEnProduccion();
        setProductos(data);
      } catch (error) {
        console.error("Error obteniendo productos en producción:", error);
      }
    };
    fetchProductos();
  }, [navigate]);

  // 📌 Obtener timeline cuando se seleccione un producto
  useEffect(() => {
    if (selectedProduct) {
      if (timelines[selectedProduct.IdPresupuesto]) {
        setTimeline(timelines[selectedProduct.IdPresupuesto]);
      } else {
        fetchTimeline(selectedProduct.IdPresupuesto);
      }
    }
  }, [selectedProduct, timelines]); // Agregar `timelines` como dependencia para asegurarnos de que se actualice

  useEffect(() => {
    const fetchAllTimelines = async () => {
      for (const producto of productos) {
        if (!timelines[producto.IdPresupuesto]) {
          await fetchTimeline(producto.IdPresupuesto);
        }
      }
    };

    if (productos.length > 0) {
      fetchAllTimelines();
    }
  }, [productos]);

  // 📌 Función para obtener el timeline de un producto
  const fetchTimeline = async (productId) => {
    setLoading(true);
    try {
      const data = await getTimelineByProductId(productId);
      setTimelines((prevTimelines) => ({
        ...prevTimelines,
        [productId]: data, // Almacena tareas sin sobrescribir otros productos
      }));
    } catch (error) {
      console.error("❌ Error fetching timeline:", error);
    }
    setLoading(false);
  };

  const exportToExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(timeline);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Production Timeline");
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "ProductionTimeline.xlsx");
  };

  /* obtener las fotos */
  useEffect(() => {
    const fetchBudgetImages = async () => {
      if (selectedProduct?.NumeroPresupuesto) {
        try {
          const images = await getFileContent(
            selectedProduct.NumeroPresupuesto,
          );

          // 🔹 Convertimos Base64 en URLs utilizables
          const formattedImages = images.map((file) => ({
            url: `data:${file.mimeType};base64,${file.data}`,
            fileName: file.fileName,
          }));

          setBudgetImages((prev) => ({
            ...prev,
            [selectedProduct.NumeroPresupuesto]: formattedImages,
          }));
        } catch (error) {
          console.error("Error al cargar imágenes del presupuesto:", error);
        }
      }
    };

    fetchBudgetImages();
  }, [selectedProduct]);

  const timelineData = timeline.length > 0 ? timeline : [];

  const generateDates = () => {
    const dates = [];
    const start = new Date("2025-01-15");
    const end = new Date("2025-12-31");

    while (start <= end) {
      dates.push(new Date(start));
      start.setDate(start.getDate() + 1);
    }

    return dates;
  };

  const dates = generateDates();

  const timelineContainerRef = useRef(null);

  useEffect(() => {
    if (timelineContainerRef.current) {
      const todayIndex = dates.findIndex(
        (date) =>
          date.toISOString().split("T")[0] ===
          new Date().toISOString().split("T")[0],
      );

      if (todayIndex !== -1) {
        // Ajusta la posición de desplazamiento según el ancho de cada columna
        const scrollPosition = todayIndex * 50; // 50px por día, ajusta si es necesario
        timelineContainerRef.current.scrollLeft = scrollPosition;
      }
    }
  }, [dates, selectedProduct]); // Se ejecuta al cambiar `dates` o `selectedProduct`

  // 📌 Construcción del árbol optimizada con useMemo
  const treeData = useMemo(() => {
    const tree = {};

    productos.forEach((producto) => {
      const temporada = producto.TemporadaNombre || "Sin Temporada";
      const marca = producto.MarcaNombre || "Sin Marca";
      const identificador = `${producto.NumeroPresupuesto} | ${producto.DiseñoMuestra}`;

      if (!tree[temporada]) tree[temporada] = {};
      if (!tree[temporada][marca]) tree[temporada][marca] = [];

      tree[temporada][marca].push({ ...producto, identificador });
    });

    return tree;
  }, [productos]);

  // 📌 Manejar la expansión y colapso de nodos
  const toggleNode = (nodeId) => {
    setExpandedNodes((prev) => ({
      ...prev,
      [nodeId]: !prev[nodeId],
    }));
  };

  const getBackgroundColor = (taskName) => {
    const yellowTasks = [
      "SMS comments",
      "SSS Fitting send",
      "SSS Fitting comments",
      "PP send",
      "Ok production Received",
      "Testing send to lab",
      "TOP sple send",
      "TOP approved",
    ];

    const blueTasks = ["Fabrics and trims In-house", "Production Starts"];

    const redTasks = ["Inspection date", "ExFD", "ETDF", "CUT-OFF", "ETD", "DD"];

    const greenTasks = [
      "N Cartons",
      "Gross Weight Kgs",
      "Total Volume cbm",
      "Shipment Method",
      "Booking Done",
      "Forwarder",
      "Shipment Code Customer",
      "BL AWB Nr",
      "ETA",
      "Documents Approved",
      "Original Telex Docs Semt",
    ];
    const isDark = theme.palette.mode === "dark";
    if (greenTasks.includes(taskName))
      return isDark ? "#2e7d3233" : "#ffac7e3d"; // Verde opaco en dark, naranja pastel en light

    if (blueTasks.includes(taskName)) return isDark ? "#1565c033" : "#90b2b74d"; // Azul profundo

    if (yellowTasks.includes(taskName))
      return isDark ? "#fdd83533" : "#fff9c4a3"; // Amarillo vibrante

    if (redTasks.includes(taskName)) return isDark ? "#e5393533" : "#d4ff305c"; // Rojo vibrante

    return theme.palette.background.paper;
  };

  const getDelayColor = (updatedDate, realDate, delay) => {
    const today = new Date();
    const updated = updatedDate ? new Date(updatedDate) : null;
    const real = realDate ? new Date(realDate) : null;

    delay = delay ?? 0; // Si `delay` es undefined, tratarlo como 0

    if (!updated) {
      return "grey"; // 🔘 Si no hay UpdatedDate, el estado es gris.
    }

    if (delay < 0) {
      return "green"; // ✅ Si `delay` es negativo, marcar en verde.
    }

    const diffDays = Math.ceil((updated - today) / (1000 * 60 * 60 * 24));

    if (delay > 5) {
      return "red";
    }

    if (real) {
      if (real <= updated) {
        return "green";
      } else {
        return "red";
      }
    } else {
      if (diffDays < 5) {
        return "red";
      }
      if (diffDays <= 10) {
        return "orange";
      }
    }

    return "green";
  };

  const getProductTimeline = (productId) => {
    return timelines[productId] || []; // Asegura que devuelve un array aunque no haya tareas
  };

  const getProductStatusColor = (productId) => {
    const productTimeline = getProductTimeline(productId);

    if (!productTimeline || productTimeline.length === 0) {
      return "green";
    }

    let hasOrange = false;

    for (const task of productTimeline) {
      const color = getDelayColor(task.UpdatedDate, task.RealDate, task.Delay);

      if (color === "red") {
        return "red";
      }

      if (color === "orange") {
        hasOrange = true;
      }
    }

    if (hasOrange) {
      return "orange";
    }

    return "green";
  };

  const handleDateChange = async (taskId, field, newValue) => {
    try {
      const formattedDate = newValue
        ? dayjs(newValue).format("YYYY-MM-DD")
        : null;

      const currentTask = timeline.find((task) => task.Id === taskId);
      if (!currentTask) return;

      const updatedTask = {
        ExpectedDate:
          field === "ExpectedDate" ? formattedDate : currentTask.ExpectedDate,
        UpdatedDate:
          field === "UpdatedDate" ? formattedDate : currentTask.UpdatedDate,
        RealDate: field === "RealDate" ? formattedDate : currentTask.RealDate,
      };

      let delay = null;
      if (updatedTask.RealDate && updatedTask.ExpectedDate) {
        const expectedDate = new Date(updatedTask.ExpectedDate);
        const realDate = new Date(updatedTask.RealDate);
        delay = Math.ceil((realDate - expectedDate) / (1000 * 60 * 60 * 24));
      }

      await updateTimelineTask(taskId, { ...updatedTask, Delay: delay });

      setTimeline((prevTimeline) =>
        prevTimeline.map((task) =>
          task.Id === taskId ? { ...task, ...updatedTask, Delay: delay } : task,
        ),
      );

      setTimelines((prevTimelines) => ({
        ...prevTimelines,
        [selectedProduct.IdPresupuesto]: prevTimelines[
          selectedProduct.IdPresupuesto
        ].map((task) =>
          task.Id === taskId ? { ...task, ...updatedTask, Delay: delay } : task,
        ),
      }));

      // 🔹 Bloquear ExpectedDate solo si ya tiene un valor
      if (field === "ExpectedDate" && formattedDate) {
        setEditableExpectedDates((prev) => ({
          ...prev,
          [taskId]: false,
        }));
      }
    } catch (error) {
      console.error("❌ Error actualizando la fecha:", error);
    }
  };

  const updateTaskDate = async (taskId, field, newValue) => {
    try {
      const formattedDate = newValue
        ? dayjs(newValue).format("YYYY-MM-DD")
        : null;

      const currentTask = timeline.find((task) => task.Id === taskId);
      if (!currentTask) return;

      const updatedTask = {
        ExpectedDate:
          field === "ExpectedDate" ? formattedDate : currentTask.ExpectedDate,
        UpdatedDate:
          field === "UpdatedDate" ? formattedDate : currentTask.UpdatedDate,
        RealDate: field === "RealDate" ? formattedDate : currentTask.RealDate,
      };

      let delay = null;
      if (updatedTask.RealDate && updatedTask.ExpectedDate) {
        const expectedDate = new Date(updatedTask.ExpectedDate);
        const realDate = new Date(updatedTask.RealDate);
        delay = Math.ceil((realDate - expectedDate) / (1000 * 60 * 60 * 24));
      }

      await updateTimelineTask(taskId, { ...updatedTask, Delay: delay });

      setTimeline((prevTimeline) =>
        prevTimeline.map((task) =>
          task.Id === taskId ? { ...task, ...updatedTask, Delay: delay } : task,
        ),
      );

      setTimelines((prevTimelines) => ({
        ...prevTimelines,
        [selectedProduct.IdPresupuesto]: prevTimelines[
          selectedProduct.IdPresupuesto
        ].map((task) =>
          task.Id === taskId ? { ...task, ...updatedTask, Delay: delay } : task,
        ),
      }));
    } catch (error) {
      console.error("❌ Error actualizando la fecha:", error);
    }
  };

  return (
    <Box sx={{ display: "flex", padding: 2, gap: 2, ...contentMargin }}>
      {/* 📌 TreeView a la Izquierda */}
      <Card
        sx={{
          width: "27%",
          maxHeight: "120vh",
          overflowY: "auto",
        }}
      >
        <CardContent>
          <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
            Productos en Producción
          </Typography>

          {Object.keys(treeData).length > 0 ? (
            // ✅ Eliminamos el TreeView raíz innecesario
            Object.entries(treeData).map(([temporada, marcas]) => {
              if (Object.keys(marcas).length === 0) return null; // Evita nodos vacíos

              return (
                <TreeView
                  key={temporada}
                  nodeLabel={
                    <Box
                      onClick={() => toggleNode(temporada)}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        cursor: "pointer",
                        padding: ".5em 0",
                        fontWeight: 700,
                      }}
                    >
                      <AccountTreeOutlinedIcon
                        sx={{ color: "#90b2b7", marginRight: ".5em" }}
                      />
                      {temporada}
                    </Box>
                  }
                  collapsed={!expandedNodes[temporada]}
                >
                  {Object.entries(marcas).map(([marca, productos]) => {
                    if (productos.length === 0) return null; // Evita nodos vacíos

                    return (
                      <TreeView
                        key={marca}
                        nodeLabel={
                          <Box
                            onClick={() => toggleNode(marca)}
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              padding: ".5em 0",
                              fontWeight: 700,
                            }}
                          >
                            <FolderOpenIcon
                              sx={{ color: "#90b2b7", marginRight: ".5em" }}
                            />
                            {marca}
                          </Box>
                        }
                        collapsed={!expandedNodes[marca]}
                      >
                        {productos.map((producto) => {
                          return (
                            <div
                              key={producto.IdPresupuesto}
                              style={{
                                paddingLeft: "1em",
                                cursor: "pointer",
                                padding: ".5em 0",
                                color:
                                  selectedProduct?.IdPresupuesto ===
                                  producto.IdPresupuesto
                                    ? "black"
                                    : "grey",
                                backgroundColor:
                                  selectedProduct?.IdPresupuesto ===
                                  producto.IdPresupuesto
                                    ? "#90b2b7"
                                    : theme.palette.background.paper,
                                fontWeight: 700,
                                fontSize: ".8em",
                                display: "flex",
                                alignItems: "center",
                                gap: "0.5em",
                              }}
                              onClick={() => setSelectedProduct(producto)}
                            >
                              {/* 🔵 Bola de estado del producto */}
                              <Box
                                sx={{
                                  width: 10,
                                  height: 10,
                                  ml: 1,
                                  borderRadius: "50%",
                                  backgroundColor: timelines[
                                    producto.IdPresupuesto
                                  ]
                                    ? getProductStatusColor(
                                        producto.IdPresupuesto,
                                      )
                                    : "grey", // Muestra gris si no hay timeline cargado aún
                                }}
                              />

                              {producto.identificador}
                            </div>
                          );
                        })}
                      </TreeView>
                    );
                  })}
                </TreeView>
              );
            })
          ) : (
            <Typography sx={{ color: "gray", fontSize: "0.9em" }}>
              No hay productos en producción.
            </Typography>
          )}
        </CardContent>
      </Card>

      {/* 📌 Tarjeta del Producto Seleccionado */}
      {selectedProduct && (
        <Card
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            background: "transparent",

            boxShadow: "none",
          }}
        >
          <Box
            sx={{
              display: "flex",
              border: `1px solid ${theme.palette.divider}`,
              justifyContent: "space-between",
              backgroundColor: theme.palette.background.paper,
              borderRadius: "6px",
              mb: 1.5,
              flexDirection: {
                xs: "column",
                sm: "column",
                md: "column",
                lg: "row",
              },
            }}
          >
            {" "}
            <Box
              sx={{
                display: "flex",
              }}
            >
              <CardContent sx={{ minWidth: 275 }}>
                <CardHeader
                  avatar={
                    <Avatar sx={{ bgcolor: "#FFAC7E" }} aria-label="recipe">
                      C
                    </Avatar>
                  }
                  title={selectedProduct.CLiente}
                  subheader={selectedProduct.MarcaNombre}
                  sx={{
                    "& .MuiCardHeader-title": {
                      fontSize: "1.2em",
                      fontWeight: 800,
                    },
                    "& .MuiCardHeader-subheader": {
                      fontSize: "1em",
                      fontWeight: 800,
                      color: "#FFAC7E",
                    },
                  }}
                />
                {/* descargar excel */}
                <Box sx={{ display: "flex" }}>
                  <Box
                    sx={{
                      ml: 2,
                    }}
                  >
                    <Tooltip
                      title="Descargar Excel"
                      PopperProps={{
                        modifiers: [
                          {
                            name: "offset",
                            options: {
                              offset: [0, -10],
                            },
                          },
                        ],
                      }}
                    >
                      <IconButton
                        component="span"
                        aria-label="upload"
                        onClick={exportToExcel}
                        sx={{
                          color: "#34afc7",
                          "&.MuiIconButton-root": {
                            border: "1px solid #34afc7",
                          },

                          "&:hover": {
                            backgroundColor: "#34afc7",
                            color: "#fff",
                          },
                        }}
                      >
                        <CloudDownloadIcon />
                      </IconButton>
                    </Tooltip>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        fontSize: "1.2em",
                        ml: 2,
                        color: "#90b2b7",
                      }}
                    >
                      {selectedProduct.NumeroPresupuesto}
                    </Typography>
                    <Typography
                      sx={{ fontWeight: "bold", fontSize: "1.2em", ml: 2 }}
                    >
                      {selectedProduct.DiseñoMuestra}
                    </Typography>
                  </Box>{" "}
                </Box>
              </CardContent>

              <CardContent sx={{ minWidth: 275 }}>
                <CardHeader
                  title={selectedProduct.TemporadaNombre}
                  subheader={selectedProduct.ProveedorNombre}
                  sx={{
                    "& .MuiCardHeader-title": {
                      fontSize: "1.2em",
                      fontWeight: 800,
                    },
                    "& .MuiCardHeader-subheader": {
                      fontSize: "1em",
                      fontWeight: 800,
                      color: "#FFAC7E",
                    },
                  }}
                />

                <Typography
                  variant="h6"
                  sx={{ fontSize: "1.2em", ml: 2, fontWeight: "bold" }}
                >
                  Unidades:{" "}
                  <span style={{ color: "#90b2b7", fontWeight: "bold" }}>
                    {new Intl.NumberFormat("es-ES", {
                      maximumFractionDigits: 0,
                      useGrouping: true,
                    }).format(selectedProduct.Units)}
                  </span>
                </Typography>
                <Typography
                  variant="h6"
                  sx={{ fontSize: "1.2em", ml: 2, fontWeight: "bold" }}
                >
                  Estado:{" "}
                  <span style={{ color: "#90b2b7", fontWeight: "bold" }}>
                    {selectedProduct.PresupuestoEstado}
                  </span>
                </Typography>
              </CardContent>
            </Box>
            {/* fotos */}
            <Box sx={{ display: "flex", overflowX: "auto", p: 1, mb: 2 }}>
              {budgetImages[selectedProduct.NumeroPresupuesto]?.map(
                (file, index) => (
                  <Box
                    key={index}
                    sx={{
                      minWidth: 250,
                      width: 250,
                      height: "11em",
                      mt: 2,
                      mr: 2,
                      ml: 2,
                      border: "1px solid #FFAC7E",
                      borderRadius: "6px",
                      p: 0.2,
                      cursor: "pointer",
                    }}
                    onMouseEnter={(e) => handleMouseEnterThumb(e, file.url)}
                    onMouseLeave={handleMouseLeaveThumb}
                  >
                    <img
                      src={file.url}
                      alt="Presupuesto"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "6px",
                      }}
                    />
                  </Box>
                ),
              )}
            </Box>
            {/* 📌 Popover para mostrar la miniatura */}
            <Popover
              open={Boolean(anchorEl)}
              anchorEl={anchorEl}
              onClose={handlePopoverLeave}
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
              }}
              transformOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
              disableRestoreFocus
              PaperProps={{
                onMouseEnter: handlePopoverEnter,
                onMouseLeave: handlePopoverLeave,
                sx: { pointerEvents: "auto" },
              }}
            >
              {hoveredImage && (
                <img
                  src={hoveredImage}
                  alt="Miniatura"
                  style={{
                    width: "250px",
                    height: "auto",
                    objectFit: "cover",
                    padding: "8px",
                  }}
                />
              )}
            </Popover>
            {/* fotos */}
          </Box>

          {/* 📌 Timeline Table */}
          <Box
            sx={{
              flex: 4,
              overflowX: "auto",
              backgroundColor: theme.palette.background.paper,
              borderRadius: "6px",
              boxShadow:
                "1px 1px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12)",
            }}
          >
            <CardContent
              sx={{ display: "flex", flexDirection: "row" /* gap: 2  */ }}
            >
              <Box sx={{ width: "50em", mt: 3.5 }}>
                <Box>
                  <Box sx={{ display: "flex" /*  mt: 3.5  */ }}>
                    <Typography sx={{ width: "12em", fontWeight: 800 }}>
                      Task
                    </Typography>
                    <Typography sx={{ width: "7em", fontWeight: 800 }}>
                      Expected
                    </Typography>
                    <Typography sx={{ width: "7em", fontWeight: 800 }}>
                      Updated
                    </Typography>
                    <Typography sx={{ width: "7em", fontWeight: 800 }}>
                      Real
                    </Typography>
                    <Typography sx={{ width: "3em", fontWeight: 800 }}>
                      Delay
                    </Typography>
                  </Box>
                  <Divider sx={{ pt: 0.4 }} />
                </Box>

                {loading ? (
                  <Typography>Cargando timeline...</Typography>
                ) : timeline.length > 0 ? (
                  timeline.map((task, index) => (
                    <Box
                      key={index}
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 0.1,
                        background: getBackgroundColor(task.TaskName), // 🎨 Aplicar color de fondo
                        paddingY: ".1em",
                      }}
                    >
                      <Typography
                        sx={{
                          width: "11em",
                          pl: 1,
                          fontSize: ".8em",
                          fontWeight: 800,
                        }}
                      >
                        {task.TaskName}
                      </Typography>

                      {/* Expected Date con botón de edición */}
                      <Box sx={{ display: "flex", alignItems: "center" }}>
                        {/* Solo mostrar el lápiz si ExpectedDate ya tiene un valor */}
                        {task.ExpectedDate && (
                          <IconButton
                            size="small"
                            onClick={() =>
                              setEditableExpectedDates((prev) => ({
                                ...prev,
                                [task.Id]: !prev[task.Id],
                              }))
                            }
                            sx={{
                              color: editableExpectedDates[task.Id]
                                ? "#34afc7"
                                : "grey",
                            }}
                          >
                            <EditIcon sx={{ height: ".59em" }} />
                          </IconButton>
                        )}

                        {!task.ExpectedDate && (
                          <IconButton
                            size="small"
                            sx={{
                              color: "transparent",
                            }}
                          >
                            <EditIcon sx={{ height: ".59em" }} />
                          </IconButton>
                        )}

                        <TextField
                          sx={styles.LineasCalendar}
                          size="small"
                          type="date"
                          value={
                            task.ExpectedDate
                              ? dayjs(task.ExpectedDate).format("YYYY-MM-DD")
                              : ""
                          }
                          onChange={(e) =>
                            handleDateChange(
                              task.Id,
                              "ExpectedDate",
                              e.target.value,
                            )
                          }
                          disabled={
                            task.ExpectedDate && !editableExpectedDates[task.Id]
                          } // Solo se bloquea si ya tiene valor
                        />
                      </Box>

                      {/* Updated Date */}
                      <TextField
                        sx={styles.LineasCalendar}
                        size="small"
                        type="date"
                        value={
                          task.UpdatedDate
                            ? dayjs(task.UpdatedDate).format("YYYY-MM-DD")
                            : ""
                        }
                        InputLabelProps={{ shrink: true }} // 🔹 Mantiene el label flotante cuando se edita manualmente
                        onChange={(e) =>
                          handleDateChange(
                            task.Id,
                            "UpdatedDate",
                            e.target.value,
                          )
                        }
                        onBlur={(e) => {
                          const formattedDate = dayjs(e.target.value).isValid()
                            ? dayjs(e.target.value).format("YYYY-MM-DD")
                            : "";
                          handleDateChange(
                            task.Id,
                            "UpdatedDate",
                            formattedDate,
                          );
                        }}
                      />

                      {/* Real Date */}
                      <TextField
                        sx={styles.LineasCalendar}
                        size="small"
                        type="date"
                        value={
                          task.RealDate
                            ? dayjs(task.RealDate).format("YYYY-MM-DD")
                            : ""
                        }
                        onChange={(e) =>
                          handleDateChange(task.Id, "RealDate", e.target.value)
                        }
                      />

                      {/* Delay */}
                      <Typography
                        sx={{
                          width: "4em",
                          textAlign: "center",
                          fontSize: ".8em",
                          fontWeight: "bold",
                          color:
                            task.Delay < 0
                              ? "green" // 🟢 Si delay es negativo, marcar en verde.
                              : getDelayColor(
                                  task.UpdatedDate,
                                  task.RealDate,
                                  task.Delay,
                                ),
                        }}
                      >
                        {task.RealDate
                          ? `${task.Delay} días`
                          : task.UpdatedDate
                            ? getDelayColor(
                                task.UpdatedDate,
                                task.RealDate,
                                task.Delay,
                              ) === "red"
                              ? "🔴"
                              : getDelayColor(
                                    task.UpdatedDate,
                                    task.RealDate,
                                    task.Delay,
                                  ) === "green"
                                ? "🟢"
                                : "🟠"
                            : "N/A"}
                      </Typography>
                      <Dialog
                        open={confirmDialogOpen}
                        onClose={() => setConfirmDialogOpen(false)}
                        sx={{
                          "& .MuiBackdrop-root": {
                            backgroundColor: "rgba(0, 0, 0, 6%)",
                          },
                          "& .MuiDialog-paper": { boxShadow: "none" },
                        }}
                      >
                        <DialogTitle>Confirm date block</DialogTitle>
                        <DialogContent>
                          <DialogContentText>
                            Once the Expected Date is set, it cannot be
                            modified. Do you wish to continue?
                          </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                          <Button
                            onClick={() => setConfirmDialogOpen(false)}
                            sx={{ color: "red" }}
                          >
                            Cancel
                          </Button>
                          <Button
                            onClick={() => {
                              setConfirmDialogOpen(false);
                              updateTaskDate(
                                pendingTask,
                                "ExpectedDate",
                                pendingDate,
                              );
                            }}
                            /* color="secondary" */
                            autoFocus
                            sx={{ color: "#90b2b7" }}
                          >
                            Confirm
                          </Button>
                        </DialogActions>
                      </Dialog>
                    </Box>
                  ))
                ) : (
                  <Typography>
                    No hay tareas registradas para este producto.
                  </Typography>
                )}
              </Box>

              {/*  */}

              {/* Timeline */}
              <Box
                ref={timelineContainerRef}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  overflowX: "auto",
                  borderLeft: `1px solid ${theme.palette.divider}`,
                  position: "relative", // Necesario para la línea roja fija
                  scrollBehavior: "smooth",
                  overflowY: "hidden",
                }}
              >
                {/* Línea vertical para el día de hoy */}
                {dates.some(
                  (date) =>
                    date.toISOString().split("T")[0] ===
                    new Date().toISOString().split("T")[0],
                ) && (
                  <>
                    {/* Línea izquierda */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: `${
                          dates.findIndex(
                            (date) =>
                              date.toISOString().split("T")[0] ===
                              new Date().toISOString().split("T")[0],
                          ) * 50
                        }px`,
                        height: "100%",
                        width: "2px",
                        backgroundColor: "#90b2b7",
                        zIndex: 10,
                        mt: 5,
                      }}
                    />

                    {/* Línea derecha */}
                    <Box
                      sx={{
                        position: "absolute",
                        top: 0,
                        left: `${
                          dates.findIndex(
                            (date) =>
                              date.toISOString().split("T")[0] ===
                              new Date().toISOString().split("T")[0],
                          ) *
                            50 +
                          48 // Desplaza la línea 48px a la derecha (ajústalo si es necesario)
                        }px`,
                        height: "100%",
                        width: "2px",
                        backgroundColor: "#90b2b7",
                        zIndex: 10,
                        mt: 5,
                      }}
                    />
                  </>
                )}

                {/* Header de Meses */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    /* borderBottom: "1px solid #ccc", */
                    marginBottom: 1,
                    paddingBottom: 1,
                  }}
                >
                  {dates.map((date, index) => {
                    const isFirstOfMonth =
                      index === 0 ||
                      date.getMonth() !== dates[index - 1].getMonth();
                    return isFirstOfMonth ? (
                      <Box
                        key={`month-${index}`}
                        sx={{
                          minWidth:
                            50 *
                            dates.filter(
                              (d) => d.getMonth() === date.getMonth(),
                            ).length,
                          textAlign: "center",
                          fontWeight: "bold",
                          fontSize: 14,
                          borderBottom: `1px solid ${theme.palette.divider}`,
                          pb: 0.5,
                        }}
                      >
                        {date.toLocaleDateString("en-US", {
                          month: "short",
                          year: "numeric",
                        })}
                      </Box>
                    ) : null;
                  })}
                </Box>

                {/* Header de Días */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",

                    paddingBottom: 1,
                  }}
                >
                  {dates.map((date, index) => {
                    const isToday =
                      date.toISOString().split("T")[0] ===
                      new Date().toISOString().split("T")[0];
                    return (
                      <Box
                        key={`day-${index}`}
                        sx={{
                          minWidth: 50,
                          textAlign: "center",
                          fontSize: "12px",
                          fontWeight: "bold",
                          color: isToday ? "red" : "inherit", // Resaltar el número de hoy en rojo
                          backgroundColor: isToday ? "#90b2b7" : "inherit",

                          borderBottom: `1px solid ${theme.palette.divider}`,
                          pb: 0.5,
                        }}
                      >
                        {date.getDate()}
                      </Box>
                    );
                  })}
                </Box>

                {/* Rows del Timeline */}
                {timelineData.map((task, rowIndex) => (
                  <Box
                    key={`timeline-row-${rowIndex}`}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      position: "relative",

                      /* pt: 0.3,*/
                      pb: 1.1,
                      minHeight: "1.4em",
                      height: "1.5em",
                    }}
                  >
                    {dates.map((date, index) => {
                      const formattedDate = date.toISOString().split("T")[0];

                      const isExpected = formattedDate === task.ExpectedDate;
                      const isUpdated = formattedDate === task.UpdatedDate;
                      const isReal = formattedDate === task.RealDate;

                      return (
                        <Box
                          key={`dot-${rowIndex}-${index}`}
                          sx={{
                            minWidth: 50,
                            /*  minHeight: "1.4em", */
                            height: "1.5em",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            position: "relative",
                            borderBottom: `1px solid ${theme.palette.divider}`,
                          }}
                        >
                          {isExpected && (
                            <Box
                              sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: "#D4FF30",
                                borderRadius: "50%",
                                position: "relative",
                                zIndex: 3,
                              }}
                            />
                          )}

                          {isUpdated && (
                            <Box
                              sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: "orange",
                                borderRadius: "50%",
                                position: isExpected ? "absolute" : "relative",
                                top: isExpected ? 16 : "unset",
                                zIndex: 2,
                              }}
                            />
                          )}

                          {isReal && (
                            <Box
                              sx={{
                                width: 12,
                                height: 12,
                                backgroundColor: "red",
                                borderRadius: "50%",
                                position:
                                  isUpdated || isExpected
                                    ? "absolute"
                                    : "relative",
                                top: isUpdated ? 16 : isExpected ? 32 : "unset",
                                zIndex: 1,
                              }}
                            />
                          )}
                        </Box>
                      );
                    })}
                  </Box>
                ))}
              </Box>
              {/*  */}
            </CardContent>
          </Box>
        </Card>
      )}
    </Box>
    /* </Box> */
  );
};

export default CriticalPath;
